import { render } from "./ContainerTrailerPageList.vue?vue&type=template&id=15bdba72&scoped=true&ts=true"
import script from "./ContainerTrailerPageList.vue?vue&type=script&lang=ts"
export * from "./ContainerTrailerPageList.vue?vue&type=script&lang=ts"

import "./ContainerTrailerPageList.vue?vue&type=style&index=0&id=15bdba72&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bdba72"]])

export default __exports__